import HourTypeFormatter from './HourTypeFormatter.vue';
import PriceFormatter from './PriceFormatter.vue';
import i18n from 'src/i18n';

const configTable = () => {
  const tableColumns = [
    {
      prop: 'code',
      label: i18n.t('common_words.code'),
      align: 'center',
      sortable: true,
    },
    {
      prop: 'name',
      label: i18n.t('common_words.name'),
      minWidth: 150,
      sortable: true,
    },
    {
      prop: 'price',
      label: i18n.t('labor.hour_value'),
      minWidth: 150,
      sortable: true,
      align: 'center',
      formatter: PriceFormatter,
    },
    {
      prop: 'hour_type',
      label: i18n.t('labor.hour_format'),
      minWidth: 180,
      sortable: true,
      align: 'center',
      formatter: HourTypeFormatter,
    },
    {
      prop: 'start_date',
      label: i18n.t('common_words.start_date'),
      align: 'center',
      sortable: true,
      show: true,
    },
    {
      prop: 'end_date',
      label: i18n.t('common_words.end_date'),
      align: 'center',
      sortable: true,
      show: true,
    },
  ];

  return { tableColumns };
};

export default configTable;
